import React from 'react'; 
import PropTypes from 'prop-types';
// import Button from 'react-bootstrap/lib/Button';
const FortisButton = ({ text, onClick, error, style }) => {
  return (
    // <div>
    //   <Button className="step-btn" onClick={onClick} >
    //     <div><img src="../../images/ButtonLeftPart.png" /></div>
    //     <div className="step-btn-middle">{text}</div>
    //     <div><img src="../../images/ButtonRightPart.png" /></div>
    //   </Button>
    //   {error && <div className="alert alert-danger">{error}</div>}
    // </div>
    <div style={style}>
      <button type="button" className="btn btn-primaryOSA" role="button" onClick={onClick}>{text}</button>
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

FortisButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default FortisButton;


